<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/vhjPj6/tc-custom/9781452145013.jpg?1700289827562" alt="This image is the cover for the book Home Style by City"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Home Style by City
      </h1>
      <p class="bookDescription body article font2">
        <b>“Features five design-focused metropolises . . . and funky spaces that reflect the sensibilities of life there . . . It has visual inspiration galore.” —<i>Refinery29</i></b><br/><br/>Explore the world’s most stylish and eclectic residences in this inspired armchair décor guide. <i>Home Style by City</i> captures the essence of five design-forward cities, featuring gorgeously decorated homes from each that reflect local style and inspire internationally. Part city tour—including must-visit flea markets, bits of colorful history, and curated lists of music, books, and films—and part design resource for achieving the various looks, this refreshing perspective on décor shows how cities themselves impact interiors. Illuminating text invites readers into page after page of lavishly photographed interiors, offering deceptively simple transitions and insider tips to bring the look into any space. Visually rich and totally inspiring, <i>Home Style by City</i> is a treasure for lovers of design, travel, and, of course, big city dreams.<br/><br/>“From character and cultural heritage, each section offers up tips for decorating in this eclectic-bohemian style from where to shop (flea markets) while in these cities to ‘get the look’ ideas and DIYs to create your own favorite city-inspired look.” —<i>Poppytalk</i><br/><br/>“Ida’s book is loaded with wonderful images of her friends’ stylish homes who are collectors of vintage finds. She also lists favorite flea markets, best movies to watch, books to read, and music to listen to.” —<i>A Well Lived House</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ida Magntorn
      </h2>
      
      <p class="authorDescription body article">Ida Magntorn is a Swedish photographer, stylist, and writer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6722c208